// Comunidades: lo que ve el administrador y lo que ve el miembro.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Communities: admin ----

export const adminListCommunities = async () => {
  const { data } = await api.get("/admin/communities");
  return data;
};

export const adminCreateCommunity = async (payload) => {
  const { data } = await api.post("/admin/communities", payload);
  return data;
};

// El alta de una clase entera. Las contrasenas vuelven EN CLARO y una sola vez: van a un
// papel. No hay forma de volver a pedirlas, y es a proposito.
// `autorizaciones` y `etapa` VIAJABA NINGUNO, y ahí estaba el fallo: el backend sabía
// recibir la declaración del centro —la que desbloquea el permiso del tutor para una clase
// entera de menores de 14— y esta función no la mandaba nunca. Construido, probado, y sin
// forma de llegar. El curso hace lo propio: con él, cada cuenta nueva nace con su nivel y
// nadie tiene que contestarlo uno a uno.
export const adminAltaEnLote = async (id, correos, { autorizaciones = false, etapa = "" } = {}) => {
  const { data } = await api.post(`/admin/communities/${id}/alta-en-lote`, {
    correos, autorizaciones_centro: autorizaciones, etapa,
  });
  return data;
};

// Genera o RENUEVA el codigo de entrada. Renovar es como se cierra una puerta que se
// proyecto en una pizarra y acabo en el movil de quien no era de la clase.
export const adminPonCodigo = async (id) => {
  const { data } = await api.post(`/admin/communities/${id}/codigo`);
  return data.codigo;
};

// El alumno se mete solo con el codigo. Repetirlo no duplica la membresia.
export const entrarConCodigo = async (codigo) => {
  const { data } = await api.post("/communities/entrar", { codigo });
  return data;
};

// ---- Tareas: lo que se manda a una clase, con fecha ----

export const adminListTareas = async (id) => {
  const { data } = await api.get(`/admin/communities/${id}/tareas`);
  return data.tareas ?? [];
};

export const adminCreaTarea = async (id, payload) => {
  const { data } = await api.post(`/admin/communities/${id}/tareas`, payload);
  return data;
};

export const adminBorraTarea = async (id, tareaId) => {
  const { data } = await api.delete(`/admin/communities/${id}/tareas/${tareaId}`);
  return data;
};

// Lo que le han mandado a este alumno en TODAS sus clases.
export const misTareas = async () => {
  const { data } = await api.get("/communities/mis-tareas");
  return data.tareas ?? [];
};

// ---- El acceso completo de una clase (el piloto del instituto) ----
//
// Tres llamadas y no una con un interruptor: abrir y cerrar son acciones distintas con
// consecuencias distintas, y con un `PUT {activa}` cerrarle el acceso a 180 alumnos seria un
// caracter de diferencia respecto a abrirlo.

export const estadoPromoClase = async (id) => {
  const { data } = await api.get(`/admin/communities/${id}/promo`);
  return data;
};

// Sin `hasta`, el servidor pone el fin de curso: es la red por si nadie pulsa el otro boton.
export const abrePromoClase = async (id, hasta = "") => {
  const { data } = await api.post(`/admin/communities/${id}/promo`, { hasta });
  return data;
};

// Solo baja a quien tenia el acceso POR esta clase. Al que ademas paga no se le toca.
export const cierraPromoClase = async (id) => {
  const { data } = await api.delete(`/admin/communities/${id}/promo`);
  return data;
};

// Contrasena nueva para el alumno que perdio la suya. Vuelve EN CLARO y una sola vez; la
// cuenta no se toca -mismo id, misma matricula, mismo progreso-, solo cambia la llave.
export const adminRegeneraClave = async (id, userId) => {
  const { data } = await api.post(`/admin/communities/${id}/members/${userId}/clave`);
  return data;
};

// Los profesores de la Academia (18 oct 2026): quien lo es, hacerlo por correo y quitarlo.
export const adminListProfesores = async () =>
  (await api.get("/admin/communities/profesores")).data?.profesores || [];
export const adminHazProfesor = async (correo) =>
  (await api.post("/admin/communities/profesores", { correo })).data;
export const adminQuitaProfesor = async (userId) =>
  (await api.delete(`/admin/communities/profesores/${encodeURIComponent(userId)}`)).data;

export const adminUpdateCommunity = async (id, payload) => {
  const { data } = await api.patch(`/admin/communities/${id}`, payload);
  return data;
};

export const adminArchiveCommunity = async (id) => {
  const { data } = await api.post(`/admin/communities/${id}/archive`);
  return data;
};

export const adminDeleteCommunity = async (id) => {
  const { data } = await api.delete(`/admin/communities/${id}`);
  return data;
};

export const adminListCommunityMembers = async (id) => {
  const { data } = await api.get(`/admin/communities/${id}/members`);
  return data;
};

export const adminAddCommunityMember = async (id, userId) => {
  const { data } = await api.post(`/admin/communities/${id}/members`, { user_id: userId });
  return data;
};

export const adminRemoveCommunityMember = async (id, userId) => {
  const { data } = await api.delete(`/admin/communities/${id}/members/${userId}`);
  return data;
};

export const adminMoveCommunityMember = async (userId, fromCommunityId, toCommunityId) => {
  const { data } = await api.post("/admin/communities/members/move", {
    user_id: userId,
    from_community_id: fromCommunityId,
    to_community_id: toCommunityId,
  });
  return data;
};

// ---- Communities: member-facing ----

export const getMyCommunities = async () => {
  const { data } = await api.get("/communities/mine");
  return data;
};

export const getCommunityDetail = async (id) => {
  const { data } = await api.get(`/communities/${id}`);
  return data;
};

export const getCommunityAnnouncements = async (id) => {
  const { data } = await api.get(`/communities/${id}/announcements`);
  return data;
};

export const postCommunityAnnouncement = async (id, payload) => {
  const { data } = await api.post(`/communities/${id}/announcements`, payload);
  return data;
};

export const getCommunityResources = async (id) => {
  const { data } = await api.get(`/communities/${id}/resources`);
  return data;
};

export const postCommunityResource = async (id, payload) => {
  const { data } = await api.post(`/communities/${id}/resources`, payload);
  return data;
};

export const getCommunityMembers = async (id) => {
  const { data } = await api.get(`/communities/${id}/members`);
  return data;
};

export const getCommunityMessages = async (id, since) => {
  const { data } = await api.get(`/communities/${id}/messages`, { params: since ? { since } : {} });
  return data;
};

export const postCommunityMessage = async (id, body) => {
  const { data } = await api.post(`/communities/${id}/messages`, { body });
  return data;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
